<template>
  <v-app>
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col class="py-10" align="center" justify="center">
          <v-form v-model="valForm">
            <v-card max-width="500px" elevation="5">
              <v-row align="center" justify="center">
                <v-col
                  md="12"
                  cols="12"
                  sm="12"
                  xs="12"
                  style="font-weight: bold; font-size: 20px"
                >
                  Request Your Record Locator Number
                </v-col>
                <v-col class="px-10 pl-10" md="12" cols="12" sm="12" xs="12">
                  You can either complete the information below or login and
                  look up your Record Locator Number.
                </v-col>
                <v-col md="12" cols="12" sm="12" xs="12" class="mx-2">
                  <span style="font-weight: bold">Your Role</span>
                  <div style="width: 300px">
                    <v-select
                      label=""
                      placeholder="Select your role"
                      v-model="selOption"
                      :items="lstOption"
                      item-value="val"
                      item-text="txt"
                      dense
                      outlined
                      hide-details
                      clearable
                      :rules="rule_Required"
                      @change="selected_option"
                    >
                      <template slot="item" slot-scope="data">
                        {{ data.item.txt }}
                      </template>
                    </v-select>
                  </div>
                </v-col>
              </v-row>
              <v-row class="text-left ml-10 mr-10">
                <v-col md="12" cols="12" sm="12" xs="12"
                  ><span style="font-weight: bold"
                    >Enter Your Email Or Mobile Number</span
                  >
                </v-col>
                <v-col cols="12" md="12" sm="12" xs="12">
                  <v-radio-group row hide-details v-model="Email_Or_Mobile">
                    <v-radio label="Email" value="1"></v-radio>
                    <v-radio label="Mobile No." value="2"></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col md="12" sm="12" xs="12" v-if="Email_Or_Mobile == '1'">
                  <v-text-field
                    v-model="selEmail"
                    dense
                    outlined
                    hide-details
                    :rules="rule_Required"
                    placeholder="Type in your email address"
                    label=""
                  ></v-text-field
                ></v-col>
                <v-col md="12" sm="12" xs="12" v-else>
                  <v-text-field
                    v-model="selMobile"
                    dense
                    outlined
                    hide-details
                    :rules="rule_Required"
                    label=""
                    placeholder="Type in your mobile number"
                  ></v-text-field
                ></v-col>
              </v-row>

              <v-row class="text-left ml-10 mr-10">
                <v-col md="6" sm="12" xs="12"
                  ><span style="font-weight: bold">Home Zip Code</span>
                </v-col>
                <v-col md="6" sm="12" xs="12">
                  <v-text-field
                    v-model="ZipCode"
                    dense
                    outlined
                    hide-details
                    label=""
                    :rules="rule_Required"
                    placeholder="Enter Zip Code"
                  ></v-text-field
                ></v-col>
              </v-row>

              <!-- <v-row
                class="text-left ml-10 mr-10"
                v-if="selOption == 4 || selOption == 2"
              >
                <v-col md="6" sm="12" xs="12"
                  ><span style="font-weight: bold">PIN</span>
                </v-col>
                <v-col md="6" sm="12" xs="12">
                  <v-text-field
                    v-model="selPIN"
                    dense
                    outlined
                    hide-details
                    label=""
                    :rules="rule_Required"
                    placeholder="Enter PIN"
                  ></v-text-field
                ></v-col>
              </v-row> -->
              <v-row class="text-left ml-10 mr-10" v-if="selOption == 3">
                <v-col md="6" sm="12" xs="12"
                  ><span style="font-weight: bold">DOB</span></v-col
                >
                <v-col md="6" sm="12" xs="12">
                  <v-menu
                    ref="menu2"
                    v-model="menu2"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        ref="txtDOB2"
                        v-mask="'##/##/####'"
                        placeholder="##/##/####"
                        append-icon="mdi-calendar"
                        v-model="DOB"
                        label=""
                        outlined
                        hide-details="true"
                        dense
                        persistent-hint
                        v-bind="attrs"
                        @click="date = parseDate(DOB)"
                        @blur="date = parseDate(DOB)"
                        v-on="on"
                        :rules="rule_DOB"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="date"
                      :max="new Date().toISOString().slice(0, 10)"
                      :min="
                        new Date('1900-01-01T00:00:00Z')
                          .toISOString()
                          .slice(0, 10)
                      "
                      no-title
                      @input="menu2 = false"
                    >
                      <div style="margin-left: 185px">
                        <v-btn
                          class="text-none"
                          text
                          color="primary"
                          @click="CloseMenu2"
                          >Close</v-btn
                        >
                      </div></v-date-picker
                    >
                  </v-menu>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <div
                    id="recaptcha"
                    ref="recaptcha"
                    class="g-recaptcha"
                    :data-sitekey="rcapt_sig_key"
                    data-expired-callback="onRecaptchaResponseExpiry"
                    data-callback="onVerify"
                  ></div>
                </v-col>
              </v-row>

              <v-row class="text-left ml-10 mr-10">
                <v-col md="6" sm="6" xs="6">
                  <v-btn
                    style="
                      background-color: #005c84;
                      border-radius: 10px !important;
                      width: 140px;
                    "
                    class="text-none white--text"
                    dense
                    small
                  >
                    Cancel
                  </v-btn>
                </v-col>
                <v-col class="text-right" md="6" sm="6" xs="6">
                  <v-btn
                    style="
                      background-color: #005c84;
                      border-radius: 10px !important;
                      width: 140px;
                    "
                    class="text-none white--text"
                    dense
                    small
                    @click="Submit()"
                    :disabled="!valForm || validated_recaptcha == 0"
                  >
                    Submit
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-form>

          <!--  Success Matched -->
          <v-dialog v-model="dgSuccess" persistent width="400px">
            <v-card class="overflow-hidden" height="100%">
              <v-toolbar height="40" headline grey lighten-2>
                <v-toolbar-title>Success!</v-toolbar-title>
                <v-spacer></v-spacer>

                <v-btn
                  icon
                  color="black"
                  size="x-small"
                  elevation="0"
                  @click="dgSuccess = false"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-row>
                <v-col class="pa-10">
                  <div style="font-weight: bold; color: green">
                    Thank You for Requesting Your Record Locator Number!
                  </div>
                  <br />
                  <div>
                    We have forwarded Your Number to the Email or Mobile Number
                    you provided.
                  </div>
                </v-col>
              </v-row>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  class="text-none"
                  style="border-radius: 10px !important"
                  @click="dgSuccess = false"
                >
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- Account Locked -->
          <v-dialog v-model="dgLocked" persistent width="400px">
            <v-card class="overflow-hidden" height="100%">
              <v-toolbar height="40" headline grey lighten-2>
                <v-toolbar-title>Alert - Account Locked</v-toolbar-title>
                <v-spacer></v-spacer>

                <v-btn
                  icon
                  color="black"
                  size="x-small"
                  elevation="0"
                  @click="dgLocked = false"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-row>
                <v-col class="pa-10">
                  <div>
                    Your account has been locked under a separate process.
                    Please contact Customer Service at:
                  </div>
                  <br />
                  <div>
                    <b>Office Hours:</b> 8:30 AM - 5:00 PM Monday, Friday;
                    Except Federal Holidays <br />
                    <b>Email:</b> Support@BASusa.com<br />
                    <b>Toll-Free:</b>
                    1.800.945.5513
                  </div>
                </v-col>
              </v-row>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  class="text-none"
                  style="border-radius: 10px !important"
                  @click="dgLocked = false"
                >
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- Too Many Attempts -->
          <v-dialog v-model="dgManyAttempts" persistent width="400px">
            <v-card class="overflow-hidden" height="100%">
              <v-toolbar height="40" headline grey lighten-2>
                <v-toolbar-title></v-toolbar-title>
                <v-spacer></v-spacer>

                <v-btn
                  icon
                  color="black"
                  size="x-small"
                  elevation="0"
                  @click="dgManyAttempts = false"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-row>
                <v-col class="pa-10">
                  <div>
                    <p style="color: red; text-align: center">
                      Ahh shucks...we still couldn't find a match this app will
                      be locked for 5-minutes as a security precaution
                    </p>
                  </div>
                  <div style="text-align: center">
                    <img src="error3.jpg" width="263px" height="248px" />
                  </div>
                  <div style="text-align: center">
                    <b>Need Assistance?</b><br />
                    Please Contact Support<br />
                    M-F 8:30 am - 5:00 pm Eastern Time<br />
                    Except Federal Holidays<br />
                    1.800.945.5513<br />
                    Support@BASusa.com <br />
                  </div>
                </v-col>
              </v-row>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  class="text-none"
                  style="border-radius: 10px !important"
                  @click="dgManyAttempts = false"
                >
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- 1st and 2nd Attempt Error -->
          <v-dialog v-model="dgError" persistent width="400px">
            <v-card class="overflow-hidden" height="100%">
              <v-toolbar height="40" headline grey lighten-2>
                <v-toolbar-title></v-toolbar-title>
                <v-spacer></v-spacer>

                <v-btn
                  icon
                  color="black"
                  size="x-small"
                  elevation="0"
                  @click="dgError = false"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-row>
                <v-col class="pa-10" v-if="count_error == 1">
                  <div>
                    <p style="color: red; text-align: center">
                      We're very sorry, but we are unable to find a match...
                    </p>
                  </div>
                  <div style="text-align: center">
                    <img src="error1.png" />
                  </div>
                  <div style="text-align: center">
                    ...Please try again. Thank You.
                  </div>
                </v-col>
                <v-col class="pa-10" v-if="count_error == 2">
                  <div>
                    <p style="color: red; text-align: center">
                      Ugh, again, we're very sorry, but we are unable to find a
                      match...
                    </p>
                  </div>
                  <div style="text-align: center">
                    <img src="error2.jpg" width="263px" height="248px" />
                  </div>
                  <div style="text-align: center">
                    ...Please try again. Thank You.
                  </div>
                </v-col>
              </v-row>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  class="text-none"
                  style="border-radius: 10px !important"
                  @click="dgError = false"
                >
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-overlay :absolute="true" :value="loading">
            <div style="text-align: center">
              <v-progress-circular
                indeterminate
                size="64"
              ></v-progress-circular>
            </div>
          </v-overlay>
          <div class="text-center"></div>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  name: "App",
  components: {},
  data: () => ({
    validated_recaptcha: 0,
    rcapt_token: null,
    rcapt_sig_key: "6Lc1iWQqAAAAADTtFFK4a_D1Blv2JFsEdTQTqBWf",
    dgLocked: false,
    dgSuccess: false,
    dgManyAttempts: false,
    dgError: false,
    ValidateResult: [],
    menu2: false,
    valForm: false,
    date: null,
    ip_address: null,
    Email_Or_Mobile: "1",
    selEmail: null,
    selMobile: null,
    selPIN: null,
    loading: false,
    ZipCode: null,
    DOB: null,
    selOption: null,
    track_error: [],
    count_error: 0,
    error_datetime: null,
    lstOption: [
      {
        val: "3",
        txt: "Employees",
      },
      {
        val: "1",
        txt: "BAS Administrator",
      },
      {
        val: "2",
        txt: "Client Administrator",
      },
      {
        val: "4",
        txt: "Broker/Consultant",
      },
    ],
    rule_Required: [(value) => !!value || "Required."],
    rule_DOB: [
      (value) => !!value || "Required.",
      (value) => (value && value.length == 10) || "Must be 7 digits.",
      (value) => moment(value).isValid() || "Invalid Date",
      (value) => {
        if (moment(value).isValid()) {
          const today = new Date();
          try {
            var selDate = new Date(value);
            if (new Date(value) < today && selDate.getFullYear() >= 1900)
              return true;
            else return false;
          } catch {
            return false;
          }
        } else return false;
      },
    ],
  }),

  created() {
    window.onVerify = this.onVerify;
    window.onRecaptchaResponseExpiry = this.onRecaptchaResponseExpiry;

    let recaptchaScript = document.createElement("script");
    recaptchaScript.setAttribute(
      "src",
      "https://www.google.com/recaptcha/api.js"
    );
    document.head.appendChild(recaptchaScript);
    this.rcapt_token = null;
  },

  mounted() {
    this.init();
  },

  methods: {
    onRecaptchaResponseExpiry() {
      this.rcapt_token = null;
      this.validated_recaptcha = 0;
    },

    onVerify: async function (token) {
      this.rcapt_token = token;
      this.validated_recaptcha = 1;
    },
    setCookie: async function (name, value, days) {
      let expires = "";
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
    },

    getCookie: async function (name) {
      const cookieArr = document.cookie.split(";");

      for (let i = 0; i < cookieArr.length; i++) {
        const cookiePair = cookieArr[i].trim();

        // Check if this cookie is the one we want
        if (cookiePair.startsWith(name + "=")) {
          return cookiePair.split("=")[1]; // Return the cookie value
        }
      }

      return null; // Return null if the cookie isn't found
    },

    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },

    CloseMenu2() {
      this.menu2 = false;
      this.$refs.txtDOB2.focus();
    },

    selected_option() {},

    Submit: async function () {
      var self = this;

      var re_ = await self.onSubmit(self.rcapt_token);

      if (re_ == 1) {
        if (
          self.count_error >= 3 &&
          self.areDatesWithinFiveMinutes(
            new Date(self.error_datetime),
            new Date()
          )
        ) {
          self.dgManyAttempts = true;
        } else {
          if (self.selOption == "1") {
            self.validate_EE();
          } else if (self.selOption == 2 || self.selOption == 4) {
            self.validate_AdminBroker();
          }
        }
      }
    },

    async onSubmit(token) {
      var self = this;

      var re = 0;
      await axios
        .post(
          self.methodUrl +
            "/requestlocatornumber/WebService.asmx/ValidateToken",
          {
            token: token,
          }
        )
        .then((r) => {
          re = r.data.d;
        })
        .catch(() => {
          re = 0;
        });
      return re;
    },

    getUserIP: async function () {
      try {
        // Use a public API to get the user's IP address
        const response = await fetch("https://api.ipify.org?format=json");
        const data = await response.json();

        return data.ip; // Return the IP address
      } catch (error) {
        return null; // Return null in case of error
      }
    },

    validate_EE: async function () {
      var self = this;

      var result = null;
      self.loading = true;
      await axios
        .post(
          self.methodUrl + "/requestlocatornumber/WebService.asmx/validate_EE",
          {
            user_group: self.selOption,
            email_or_sms: self.Email_Or_Mobile,
            sms: self.selMobile,
            e_mail: self.selEmail,
            zip_code: self.ZipCode,
            dob: self.DOB,
          }
        )
        .then(async (r) => {
          result = JSON.parse(r.data.d);
          self.ValidateResult = result;

          if (self.ValidateResult.length > 0) {
            var re = self.ValidateResult[0];
            if (re.ACCT_LOCKED == "1") {
              self.dgLocked = true;
              self.count_error = 0;
            } else if (re.REC_LOC_NUM != "" && re.REC_LOC_NUM != null) {
              var email = "";
              if (self.email_or_sms == "1") {
                if (re.WORK_EMAIL != null && re.WORK_EMAIL != "")
                  email = re.WORK_EMAIL;
                else if (re.ALT_EMAIL != null && re.ALT_EMAIL != "")
                  email = re.ALT_EMAIL;
                if (email != "")
                  await self.SendEmail(
                    email,
                    re.FIRST_NAME,
                    re.LAST_NAME,
                    re.REC_LOC_NUM
                  );
              } else {
                self.SendSMS(
                  re.SMS_NUMBER,
                  "Your MyEnroll360 Record Locator Number is: ",
                  re.REC_LOC_NUM
                );
              }

              self.dgSuccess = true;
            }
            self.count_error = 0;
            self.setCookie("count_error", self.count_error, 1);
          } else {
            if (self.count_error > 3) {
              self.count_error = 0;
              self.count_error++;
            } else self.count_error++;
            self.error_datetime = new Date();
            self.setCookie("count_error", self.count_error, 1);
            self.setCookie("error_datetime", self.error_datetime, 1);
            if (self.count_error == 1 || self.count_error == 2) {
              self.dgError = true;
            } else if (self.count_error == 3) {
              self.dgManyAttempts = true;
            }
          }
          self.loading = false;
        })
        .catch(() => {
          self.loading = false;
        });
      return result;
    },

    validate_AdminBroker: async function () {
      var self = this;

      var result = null;
      self.loading = true;
      await axios
        .post(
          self.methodUrl +
            "/requestlocatornumber/WebService.asmx/validate_AdminBroker",
          {
            user_group: self.selOption,
            email_or_sms: self.Email_Or_Mobile,
            sms: self.selMobile,
            e_mail: self.selEmail,
            zip_code: self.ZipCode,
            pin: self.selPIN,
          }
        )
        .then(async (r) => {
          result = JSON.parse(r.data.d);
          self.ValidateResult = result;
          if (self.ValidateResult.length > 0) {
            var re = self.ValidateResult[0];
            if (re.ACCT_LOCKED == "1") {
              self.dgLocked = true;
            } else if (re.REC_LOC_NUM != "" && re.REC_LOC_NUM != null) {
              var email = "";
              if (self.email_or_sms == "1") {
                if (re.WORK_EMAIL != null && re.WORK_EMAIL != "")
                  email = re.WORK_EMAIL;
                else if (re.ALT_EMAIL != null && re.ALT_EMAIL != "")
                  email = re.ALT_EMAIL;
                if (email != "")
                  await self.SendEmail(
                    email,
                    re.FIRST_NAME,
                    re.LAST_NAME,
                    re.REC_LOC_NUM
                  );
              } else {
                self.SendSMS(
                  re.SMS_NUMBER,
                  "Your MyEnroll360 Record Locator Number is: ",
                  re.REC_LOC_NUM
                );
              }

              self.dgSuccess = true;
            }
            self.count_error = 0;
            self.setCookie("count_error", self.count_error, 1);
          } else {
            if (self.count_error > 3) {
              self.count_error = 0;
              self.count_error++;
            } else self.count_error++;
            self.error_datetime = new Date();
            self.setCookie("count_error", self.count_error, 1);
            self.setCookie("error_datetime", self.error_datetime, 1);
            if (self.count_error == 1 || self.count_error == 2) {
              self.dgError = true;
            } else if (self.count_error == 3) {
              self.dgManyAttempts = true;
            }
          }
          self.loading = false;
        })
        .catch(() => {
          self.loading = false;
        });
      return result;
    },

    SendSMS: function (sms_number, sms_text, rln) {
      var self = this;
      self.loading = true;
      var result = 0;
      axios
        .post(
          self.methodUrl + "/requestlocatornumber/WebService.asmx/SendSMS",
          {
            sms_number: sms_number,
            sms_text: sms_text,
            rln: rln,
          }
        )
        .then((r) => {
          result = r.data.d;
        })
        .catch(() => {
          result = 0;
          self.loading = false;
        });
      return result;
    },

    SendEmail: async function (
      email_address,
      first_name,
      last_name,
      rln_value
    ) {
      var self = this;

      var result = null;
      self.loading = true;
      await axios
        .post(
          self.methodUrl + "/requestlocatornumber/WebService.asmx/SendEmail",
          {
            email_address: email_address,
            first_name: first_name,
            last_name: last_name,
            rln_value: rln_value,
          }
        )
        .then((r) => {
          result = JSON.parse(r.data.d);
        })
        .catch(() => {
          self.loading = false;
        });
      return result;
    },

    areDatesWithinFiveMinutes(date1, date2) {
      const differenceInMilliseconds = Math.abs(date1 - date2);
      const differenceInMinutes = differenceInMilliseconds / (1000 * 60); // convert milliseconds to minutes
      return differenceInMinutes <= 5;
    },

    init: async function () {
      this.loading = true;
      //this.setCookie("count_error", "0", 1);
      this.count_error = await this.getCookie("count_error");
      this.error_datetime = await this.getCookie("error_datetime");
      this.ip_address = await this.getUserIP();
      this.loading = false;
    },
  },
  watch: {
    date() {
      this.DOB = this.formatDate(this.date);
    },
  },

  computed: {
    methodUrl() {
      return "https://www.request-rln.com";
      // return "http://localhost/web_projects";

      /* return location.href.toLowerCase().indexOf("bastest") > -1 ||
        location.href.toLowerCase().indexOf("myenroll") > -1
        ? "/web_projects"
        : "http://localhost/web_projects"; */
    },
  },
};
</script>

<style scoped></style>
